// extracted by mini-css-extract-plugin
export default {"post":"bmnox","image":"K1_fK","author":"K0Nid"};